module.exports = __webpack_public_path__ + "img/gold.847119fe.png";